module.exports = __webpack_public_path__ + "img/H02028-02.f4f547e1.jpg";